// Production API by default. For local development, set REACT_APP_API_BASE
// (e.g. http://localhost:2500) in client/.env.development.local — CRA reads
// that file only for `npm start`, never for production builds.
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  "https://attendance-api.greatmanagerinstitute.com";

module.exports = {
  API_BASE,
  BASE_URL: API_BASE,
  MOMENT_UI_DATE_FORMAT: "DD MMM YY",
  API_DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  API_DATE_FORMAT: "YYYY-MM-DD",
  DATE_START_FORMAT: "YYYY-MM-DD 00:00:00",
  DATE_END_FORMAT: "YYYY-MM-DD 23:59:59",
  MOMENT_FULL_MONTH: "MMMM",
  MOMENT_HOLIDAY_FORMAT: "ddd MMM D",
  EARNED_LEAVE: 5,
  OPTIONAL_HOLIDAY: 7,
  WORK_WITHOUT_PAY: 6,
  MICROSOFT_CLIENT_ID: "329c16ab-ba51-40a0-be7b-54d675ef988b",
  DEFAULT_PROFILE_PIC:
    "https://lh5.googleusercontent.com/-_8lLpray-RU/AAAAAAAAAAI/AAAAAAAAAAA/ACHi3rcVlIiKZpiJTPo5WgvSNj0JdmvaEw/s96-c/photo.jpg",
};
